<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Manifiestos</h1>
                                    <p class="text-sm text-muted mb-0">Mostrando Manifiesto - {{ data.awb }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div v-if="data.packages.length == 0 && data.hawbs.length == 0 && !loading">
                        <p class="text-sm text-muted text-center mb-0">No hay resultados.</p>
                    </div>
                    <v-table :data="data.packages" v-if="data.packages.length > 0" :title="data.awb" :is_open="data.state_id == 19"></v-table>
                    <div v-for="(item, index) in data.hawbs" :key="index">
                        <v-table :data="item.packages" :title="item.hawb" :is_open="data.state_id == 19 && globalViewOption('AwbRemovePackage')"></v-table>
                    </div>
                    <div class="w-100 pt-5" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import VTable from './table/Index'
export default {
    components: { VTable },
    data() {
        return {
            loading: true,
            awb: this.$route.params.awb,
            data: {
                packages: [],
                hawbs: []
            },
        }
    },
    mounted() {
        this.INIT()
        this.$store.dispatch('MAXPAGE')
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/awbs/' + vue.awb, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/awbs/Detail.vue